import { Avatar, Box, Button, Flex, Text } from "@chakra-ui/react";

const renderStatus = (value, submit, e) => {
  switch (value) {
    case "BLOCKED":
      return (
        <Box w={"100%"}>
          <Text color={"var(--text-red-employee)"}>Bị chặn</Text>
          <Flex mt={4} gap={"8px"} w={"100%"}>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 27px 5px 28px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit(e?.employeeId)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Reset
            </Button>
          </Flex>
        </Box>
      );
    case "ACTIVE":
      return (
        <Box>
          <Text color={"var(--color-status-employ)"}>Hoạt động</Text>
          <Flex mt={4} gap={"8px"} w={"100%"}>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              // p={"6px 27px 5px 28px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit(e?.employeeId)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Reset
            </Button>
          </Flex>
        </Box>
      );
    case "REJECTED":
      return <Text color={"var(--text-red-employee)"}>Không duyệt</Text>;
    case "APPROVED":
      return <Text color={"var(--color-status-employ)"}>Đã duyệt</Text>;
    case "PENDING":
      return (
        <Flex gap={"8px"} w={"100%"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 27px 5px 28px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() => submit("APPROVED", e?.id)}
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Duyệt
          </Button>
          <Button
            bg={"var(--color-main)"}
            color={"var(--color-option-employee-hover)"}
            border={"1px solid var(--color-option-employee-hover)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            // p={"6px 19px 5px 19px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() => submit("REJECTED", e?.id)}
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Không duyệt
          </Button>
        </Flex>
      );
    default:
      return <Text>-</Text>;
  }
};

export const formatTableValue = (value, key, submit, e) => {
  switch (key) {
    case "contact":
      const infos = value?.split("-") || [];
      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );
    case "avatar":
      return <Avatar src={value} />;

    case "status":
      return renderStatus(value, submit, e);
    default:
      return <Text>{value}</Text>;
  }
};
